import React, { useState } from 'react';

interface ChihuahuaProps {
  size?: number;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  opacity?: number;
  variant?: number; // 0 = 闭眼微笑, 1 = 睁眼好奇
}

const Chihuahua: React.FC<ChihuahuaProps> = ({
  size = 80,
  position = 'top-right',
  opacity = 0.8,
  variant = 0
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const getPositionStyle = () => {
    switch(position) {
      case 'top-left':
        return { top: '65px', left: '20px' };
      case 'top-right':
        return { top: '65px', right: '20px' };
      case 'bottom-left':
        return { bottom: '20px', left: '20px' };
      case 'bottom-right':
        return { bottom: '20px', right: '20px' };
      default:
        return { top: '65px', right: '20px' };
    }
  };

  const imageUrl = variant === 0 ? '/2.jpg' : '/3.png';

  const handleClick = () => {
    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 3000);
  };

  return (
    <>
      {/* 页面中央浮动文字 */}
      {showMessage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            pointerEvents: 'none',
            animation: 'fadeInOut 3s ease forwards',
          }}
        >
          <div
            style={{
              backgroundColor: 'rgba(58, 107, 79, 0.9)',
              color: '#fff',
              padding: '20px 40px',
              borderRadius: '24px',
              fontSize: '1.5rem',
              fontFamily: '"KaiTi", "楷体", serif',
              fontWeight: 'bold',
              textAlign: 'center',
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              border: '2px solid rgba(255,255,255,0.3)',
              backdropFilter: 'blur(10px)',
            }}
          >
            今天又是本小姐想你的一天 
          </div>
        </div>
      )}

      <div
        className="chihuahua-element"
        style={{
          position: 'fixed',
          ...getPositionStyle(),
          opacity: opacity,
          zIndex: 1000,
          pointerEvents: 'all',
          cursor: 'pointer',
          transform: isHovered ? 'scale(1.15) rotate(-3deg)' : 'scale(1)',
          transition: 'transform 0.25s ease',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <img
          src={imageUrl}
          alt="二妞"
          style={{
            width: size,
            height: size,
            objectFit: 'cover',
            borderRadius: '50%',
            boxShadow: isHovered
              ? '0 4px 16px rgba(0,0,0,0.25)'
              : '0 2px 8px rgba(0,0,0,0.15)',
            transition: 'box-shadow 0.25s ease',
            border: '2px solid rgba(255,255,255,0.8)',
          }}
        />
        {/* 悬停提示 */}
        {isHovered && (
          <div
            style={{
              position: 'absolute',
              bottom: '105%',
              left: '50%',
              transform: 'translateX(-50%)',
              backgroundColor: 'rgba(58, 107, 79, 0.85)',
              color: 'white',
              padding: '4px 10px',
              borderRadius: '12px',
              fontSize: '13px',
              whiteSpace: 'nowrap',
              marginBottom: '4px',
              pointerEvents: 'none',
              fontFamily: '"KaiTi", "楷体", serif',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
          >
            点击二妞 
          </div>
        )}
      </div>
    </>
  );
};

export default Chihuahua;
